import "./Home.css";
import profile from "./images/profile.jpg"
import { TypeAnimation } from "react-type-animation";
import { Link } from "react-router-dom";



export default function Home() {
  return (

    <div className="Home">
      <header>
      </header>
      <body className="Home-body">
        <div className="Home-content">
          <Profile />
          <ButtonBar />
        </div>
      </body>
    </div>
  );
}

function Profile() {
  return (
    <div className="Profile">
      <img className="Profile-img-home" src={profile} alt="profile-pic" />
      <TypeAnimation
        sequence={[700, "Tate Wilhelm", 1000]}
        wrapper="span"
        speed={50}
        style={{ fontSize: "2em", display: "inline-block", fontWeight: 600 }}
        repeat={Infinity}
      />
      <TypeAnimation
        sequence={[2500, "MIT Student", 2000, "Programmer", 2000, "Professional Nerd", 2000, "Photographer"]}
        wrapper="span"
        speed={50}
        style={{ fontSize: "1em", display: "inline-block", color: "#E0E0E0FF" }}
        repeat={Infinity}
      />
    </div>
  );
}

function ButtonBar() {
  return (
    <div className="Button-bar">
      <Link to="/about">
        <button id="about" className="Button" style={{ cursor: 'pointer' }}>About Me</button>
      </Link>
      <Link to="/projects">
        <button id="projects" className="Button" style={{ cursor: 'pointer' }}>Projects</button>
      </Link>
      <a href="./TateWilhelmResume.pdf" target="_blank">
        <button id="resume" className="Button" style={{ cursor: 'pointer' }}>Resume</button>
      </a>
      <Link to="/gallery">
        <button id="gallery" className="Button" style={{ cursor: 'pointer' }}>Gallery</button>
      </Link>
    </div>
  );
}


